import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Image, Alert } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import { useForm } from "react-hook-form";

const ContactUs = () => {
  const [msg, setMsg] = useState("");
  const [alertVariant, setAlertVariant] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await fetch("https://codeinputs.com/reactapi/api/codeinputs/contact_us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error("Failed to send message");
      }
      setMsg("Thanks for your response, We will get back to you soon");
      setAlertVariant("success");
      setShowAlert(true);
      reset();
    } catch (error) {
      setMsg("Error: " + error.message);
      setAlertVariant("danger");
      setShowAlert(true);
    }
  };

  return (
    <>
      <Header />
      <div className="basic-2 full-div">
        <Container>
          <Row className="distinct bg-white text-center">
            <Col md={12}>
              <h1 className="mt-2">Get in Touch with CodeInputs!</h1>
              <Image src="/graphics/images/contactUs.webp" alt="Contact Us" fluid />
            </Col>
          </Row>
          
          <Row className="distinct bg-white mb-5 p-3">
            <Col md={6}>
              <h3 className="text-center mb-4">Contact Us</h3>
              {showAlert && (
                <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)}>
                  {msg}
                </Alert>
              )}
              <Form id="contact-us-form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control type="text" {...register("name", { required: "Full Name is required" })} />
                  {errors.name && <p className="text-danger">{errors.name.message}</p>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control type="email" {...register("email", { required: "Email is required", pattern: { value: /^\S+@\S+$/i, message: "Invalid email format" } })} />
                  {errors.email && <p className="text-danger">{errors.email.message}</p>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="subject">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control type="text" {...register("subject", { required: "Subject is required" })} />
                  {errors.subject && <p className="text-danger">{errors.subject.message}</p>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control as="textarea" rows={4} {...register("message", { required: "Message is required" })} />
                  {errors.message && <p className="text-danger">{errors.message.message}</p>}
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  Send Message
                </Button>
              </Form>
              <br/><br/>
            </Col>

            <Col md={5}>
              <span className="orgspan h4">Code Inputs</span>
              <br /><br />
              <p className="mb-0"><b>Site:</b> <a href="https://www.codeinputs.com">www.codeinputs.com</a></p>
              <p className="mb-0"><b>Email:</b> codeinputs@gmail.com</p>
              <p className="mb-0"><b>Contact:</b> +91 7693890243</p>
              
              <div className="mt-2">
                <p className="mb-0"><Image src="/graphics/images/insta.webp" width="30px" /> @codeinputs_24</p>
                <p className="mb-0"><Image src="/graphics/images/fb.webp" width="30px" /> @Code Inputs</p>
                <p className="mb-0"><Image src="/graphics/images/youtube.webp" width="30px" /> @CodeInputs</p>
                <p className="mb-0"><Image src="/graphics/images/pinterest.webp" width="30px" /> @codeinputs</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
